<div class="pr-3 pl-4 h-full w-full flex flex-col overflow-auto" (window:resize)="onResize()">
  <div class="flex justify-between header-table" #pageOptionBtnGroup>
    <div class="title-page"><span class="title">Bảng tổng hợp thông tin về người khuyết tật&nbsp;</span>
      <breadcrumbs [items]="breadcrumbs"></breadcrumbs>
    </div>
    <div class="btn-option flex">
      <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
        <button nz-button class="flex items-center justify-center" nzTooltipTitle="Xuất excel"
          nzTooltipPlacement="bottom" nz-tooltip (click)="exportExcel()">
          <i nz-icon nzType="file-excel" nzTheme="twotone"></i>
        </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
        <button nz-button class="flex items-center justify-center" (click)="exportExcel()">
          Xuất excel
        </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
        <button nz-button class="flex items-center justify-center" (click)="exportExcel()">
          <i nz-icon nzType="file-excel" nzTheme="twotone"></i>
          Xuất excel
        </button>
      </ng-container>
    </div>
  </div>
  <form nz-form class="ant-advanced-search-form" #pageSearch>
    <div nz-row [nzGutter]="24">
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Năm</nz-form-label>
          <nz-form-control nzSpan="24" nzHasFeedback nzValidatingTip="Validating...">
            <nz-date-picker nzMode="year" [(ngModel)]="year" [ngModelOptions]="{standalone: true}"
              nzPlaceHolder="Nhập năm"></nz-date-picker>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Tỉnh thành</nz-form-label>
          <asc-autocomplete  [disabled]="isDisabled || isDisabled1 || isDisabled2" [ascModel]="DisProvincesControl" (ascModelChange)="changeDisProvincesACFn($event)"
            placeholder="Chọn tỉnh thành..." [getListAC]="getDisProvincesACFn">
          </asc-autocomplete>
        </nz-form-item>
      </div>
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Quận huyện</nz-form-label>
          <asc-autocomplete  [disabled]="isDisabled || isDisabled2" [ascModel]="DistrictControl" (ascModelChange)="changeDistrictACFn($event)"
            placeholder="Chọn quận huyện..." [getListAC]="getDistrictACFn">
          </asc-autocomplete>
        </nz-form-item>
      </div>
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Phường xã</nz-form-label>
          <asc-autocomplete [ascModel]="DisWardControl" (ascModelChange)="changeDisWardACFn($event)"
            placeholder="Chọn phường xã..." [getListAC]="getDisWardACFn">
          </asc-autocomplete>
        </nz-form-item>
      </div>
      <ng-container *ngIf="!isCollapse">
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Độ tuổi</nz-form-label>
          <nz-select [(ngModel)]="commonFilter.YearOld" [ngModelOptions]="{standalone: true}" nzAllowClear
            nzPlaceHolder="Chọn độ tuổi">
            <nz-option *ngFor="let type of listYearOld" [nzValue]="type.value" [nzLabel]="type.name"></nz-option>
          </nz-select>
        </nz-form-item>
      </div>
     
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Dạng tật</nz-form-label>
            <asc-autocomplete [ascModel]="disTypeOfDisabilitysControl"
              (ascModelChange)="changeDisTypeOfDisabilitysACFn($event)" placeholder="Chọn dạng tật..."
              [getListAC]="getDisTypeOfDisabilitysACFn">
            </asc-autocomplete>
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Mức độ khuyết tật</nz-form-label>
            <asc-autocomplete [ascModel]="LevelControl" (ascModelChange)="changeLevelACFn($event)"
              placeholder="Chọn mức độ khuyết tật..." [getListAC]="getLevelACFn">
            </asc-autocomplete>
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Tình trạng hôn nhân</nz-form-label>
            <nz-form-control nzSpan="24">
              <asc-autocomplete [ascModel]="MaritalStatusControl" (ascModelChange)="changeMaritalStatus($event)"
                [placeholder]="'Chọn tình trạng'" [getListAC]="getMaritalStatusACFn">
              </asc-autocomplete>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="quanHuyen">Giới tính</nz-form-label>
            <nz-form-control nzSpan="24" nzHasFeedback nzValidatingTip="Validating...">
              <nz-radio-group [(ngModel)]="commonFilter.Gender" [ngModelOptions]="{standalone: true}">
                <label nz-radio [nzValue]="-1">Tất cả</label>
                <label nz-radio [nzValue]="1">Nam</label>
                <label nz-radio [nzValue]="0">Nữ</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label [nzFor]="'infoProvider'" nzSpan="24" #label>Người cung cấp thông tin</nz-form-label>
            <nz-form-control>
              <nz-radio-group [(ngModel)]="commonFilter.InfoProvider" [ngModelOptions]="{standalone :true}" nzSpan="24">
                <label nz-radio [nzValue]="1">Người khuyết tật</label>
                <label nz-radio [nzValue]="2">Phụ huynh/ người giám hộ</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Giấy chứng nhận KT:</nz-form-label>
            <nz-form-control nzSpan="24">
              <nz-radio-group [(ngModel)]="commonFilter.CertificateTypeId" [ngModelOptions]="{standalone: true}">
                <label nz-radio [nzValue]="0">Có</label>
                <label nz-radio [nzValue]="1">Không</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Hỗ trợ giáo dục:</nz-form-label>
            <nz-form-control nzSpan="24">
              <nz-radio-group [(ngModel)]="commonFilter.SupportedEducation" [ngModelOptions]="{standalone: true}">
                <label nz-radio [nzValue]="true">Có</label>
                <label nz-radio [nzValue]="false">Không</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Tình trạng giáo dục</nz-form-label>
            <asc-autocomplete [ascModel]="caDisEducationalStatusesControl"
              (ascModelChange)="changeCaDisEducationalStatuses($event)" placeholder="Chọn tình trạng giáo dục..."
              [getListAC]="getCaDisEducationalStatusessACFn">
            </asc-autocomplete>
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Tình trạng can thiệp</nz-form-label>
            <asc-autocomplete [ascModel]="studentInterventionStatusControl"
              (ascModelChange)="changestudentInterventionStatus($event)" placeholder="Chọn tình trạng can thiệp..."
              [getListAC]="getstudentInterventionStatusACFn">
            </asc-autocomplete>
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Đang sống tại</nz-form-label>
            <nz-form-control nzSpan="24">
              <asc-autocomplete [ascModel]="CaregiverControl" (ascModelChange)="changeCaregiver($event)"
                [placeholder]="'Chọn người chăm sóc'" [getListAC]="getCaregiverACFn">
              </asc-autocomplete>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Điều kiện kinh tế gia đình</nz-form-label>
            <nz-form-control nzSpan="24">
              <asc-autocomplete [ascModel]="LivingConditionControl" (ascModelChange)="changeLivingCondition($event)"
                placeholder="Chọn hoàn cảnh..." [getListAC]="getLivingConditionACFn">
              </asc-autocomplete>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Lĩnh vực</nz-form-label>
            <nz-form-control nzSpan="24" nzErrorTip="Nhập trường thông tin bắt buộc">
              <asc-autocomplete [ascModel]="LevelOfDevelopmentTypesControl"
                (ascModelChange)="changeLevelOfDevelopmentTypes($event)" [placeholder]="'Chọn lĩnh vực...'"
                [getListAC]="getLevelOfDevelopmentTypesACFn">
              </asc-autocomplete>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Nhu cầu hỗ trợ, giáo dục</nz-form-label>
            <asc-autocomplete [ascModel]="caDisNeedOfDisabilitysControl"
              (ascModelChange)="changeCaDisNeedOfDisabilitys($event)" placeholder="Chọn nhu cầu hỗ trợ..."
              [getListAC]="getCaDisNeedOfDisabilitysACFn">
            </asc-autocomplete>
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" #label>
              Biết chính sách GD cho người khuyết tật
            </nz-form-label>
            <nz-form-control nzSpan="24">
              <nz-radio-group [(ngModel)]="commonFilter.UnderstandDisabilityPolicy"
                [ngModelOptions]="{standalone :true}">
                <label nz-radio [nzValue]="false">Chưa</label>
                <label nz-radio [nzValue]="true">Có</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" #label>
              Sự phối hợp của cộng đồng
            </nz-form-label>
            <nz-form-control nzSpan="24">
              <nz-radio-group [(ngModel)]="commonFilter.CommunityCoordination" [ngModelOptions]="{standalone :true}">
                <label nz-radio [nzValue]="false">Chưa</label>
                <label nz-radio [nzValue]="true">Có</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" #label>
              Sự phối hợp của chính quyền ban ngành địa phương
            </nz-form-label>
            <nz-form-control nzSpan="24">
              <nz-radio-group [(ngModel)]="commonFilter.LocalGovernmentCoordination"
                [ngModelOptions]="{standalone :true}">
                <label nz-radio [nzValue]="false">Chưa</label>
                <label nz-radio [nzValue]="true">Có</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>
      </ng-container>
      <div *ngIf="isCollapse === true" nz-col nzSpan="24">
        <div style="visibility: hidden; margin-top: 5px">i</div>
      </div>
    </div>
    <div nz-row>
      <div nz-col [nzSpan]="24" class="search-area">
        <button nz-button class="flex items-center justify-center" [nzTooltipTitle]="isCollapse ? 'Mở rộng' : 'Đóng'"
          nz-tooltip (click)="toggleCollapse()">
          <i nz-icon nzType="filter" nzTheme="outline"></i>
        </button>
        <button nz-button class="flex items-center justify-center" (click)="clear()" nzTooltipTitle="Xóa tìm kiếm"
          nzTooltipPlacement="bottom" nz-tooltip>
          <i nz-icon nzType="clear" nzTheme="outline"></i>
        </button>
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'" (click)="search()">
            Tìm kiếm
          </button>
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
          <button nz-button class="flex items-center justify-center" style="width: 100px;" [nzType]="'primary'"
            nzTooltipTitle="Tìm kiếm" nzTooltipPlacement="bottom" nz-tooltip (click)="search()">
            <i nz-icon nzType="search" nzTheme="outline"></i>
          </button>
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'" (click)="search()"><i nz-icon
              nzType="search" nzTheme="outline"></i>Tìm kiếm</button>
        </ng-container>
      </div>
    </div>
  </form>
  <div class="relative">
    <nz-table #Table [nzShowTotal]="rangeTemplate" nzBordered nzShowSizeChanger [nzData]="dataTable" nzSize="small"
      class="w-full absolute" [nzFrontPagination]="false" [nzTotal]="Total" [nzPageSize]="pageSize"
      [nzPageIndex]="pageIndex" [nzPageSizeOptions]="pageSizeOptions" [nzLoading]="loading"
      [nzScroll]="{y: height + 'px', x: width + 'px'}" (nzPageIndexChange)="pageIndexEvent($event)"
      (nzPageSizeChange)="pageSizeEvent($event)">
      <thead>
        <tr #pageHeaderTable>
          <th nzWidth="50px" rowspan="3" nzLeft>STT
          </th>
          <th rowspan="3" nzWidth="250px" nzLeft>Địa phương</th>
          <th rowspan="3" class="text-center" nzWidth="50px" nzLeft>Tổng</th>
          <ng-container *ngFor="let item of header1Arr">
            <th class="text-center" [rowspan]="item.rowSpan ? item.rowSpan : 1"
              [colspan]="item.colSpan ? item.colSpan : 1">
              {{ item.dataName }}
            </th>
          </ng-container>
        </tr>
        <tr #pageHeaderTable2>
          <ng-container *ngFor="let item of header2Arr">
            <th class="text-center" [rowspan]="item.rowSpan ? item.rowSpan : 1"
              [colspan]="item.colSpan ? item.colSpan : 1">
              {{ item.dataName }}
            </th>
          </ng-container>
        </tr>
        <tr #pageHeaderTable3>
          <ng-container *ngFor="let item of header2Arr">
            <th class="text-center">
              SL
            </th>
            <th class="text-center">
              %
            </th>
          </ng-container>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of Table.data; let i = index">
          <td nzLeft>{{ i + 1 + (pageIndex-1)*pageSize }}</td>
          <td nzLeft>{{data.dataName}}</td>
          <td class="text-center" nzLeft>{{data.total}}</td>
          <ng-container *ngFor="let key of header2Arr">
            <td class="text-center" *ngIf="key.id !== ''">{{data[key.id] ? data[key.id] : 0}}</td>
            <td class="text-center" *ngIf="key.id === ''"></td>
            <td class="text-center">{{ data[key.id] && data.total? (data[key.id] * 100 / data.total | number:'1.2-2')  : 0}}</td>
          </ng-container>
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>
<ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>
<ng-template #rangeTemplate let-range="range" let-total> {{ range[0] }}-{{ range[1] }} của {{ Total }} </ng-template>
